<template>
  <div>
    <div class="row">
        <div class="mx-auto col-md-12">            
            <div class="card p-3 mb-3">
              <div class="card-body">
                <div v-if="erro" class="alert alert-danger">
                    {{ erro }}
                </div>
                <b-card
                  class="mb-2"
                  header="Dados para confirmação"
                  header-tag="header">
                  
                  <p><strong>Nome:</strong> {{dadosForm.dados.nome_completo}}</p>
                  <p><strong>CPF:</strong> {{dadosForm.dados.cpf_requerente}}</p>
                  <p><strong>Data Nascimento:</strong> {{formatDate(dadosForm.dados.data_nascimento)}}</p>
                  <p><strong>Nome da mãe:</strong> {{dadosForm.dados.nome_mae}}</p>
                  <p><strong>Sexo:</strong> {{formatarSexo(dadosForm.dados.sexo)}}</p>
                  <p><strong>Tipo Documento:</strong> {{tipos[dadosForm.dados.tipo_documento].text}}</p>
                  <p><strong>Número Documento:</strong> {{dadosForm.dados.numero_documento}}</p>
                  <p><strong>Órgão Emissor:</strong> {{dadosForm.dados.orgao_emissor}}</p>
                  <p><strong>UF:</strong> {{dadosForm.dados.uf_orgao_emissor}}</p>
                  <p><strong>Data Emissão:</strong> {{formatDate(dadosForm.dados.data_emissao)}}</p>

                  <p v-if="dadosForm.dados.tipo_documento == 3"><strong>Validade Documento:</strong> {{formatDate(dadosForm.dados.data_validade)}}</p>
                  <p v-if="dadosForm.dados.tipo_documento == 3"><strong>País Emissão:</strong> {{dadosForm.dados.pais_emissao}}</p>
                  <p v-if="dadosForm.dados.tipo_documento == 4"><strong>Série Documento:</strong> {{dadosForm.dados.serie_documento}}</p>

                  <p><strong>CEP:</strong> {{dadosForm.dados.cep_endereco}}</p>
                  <p><strong>Número:</strong> {{dadosForm.dados.numero_logradouro}}</p>
                  <p><strong>Tipo Logradouro:</strong> {{dadosForm.dados.tipo_logradouro}}</p>
                  <p><strong>Logradouro:</strong> {{dadosForm.dados.endereco}}</p>
                  <p><strong>Bairro:</strong> {{dadosForm.dados.bairro}}</p>
                  <p><strong>Complemento:</strong> {{dadosForm.dados.complemento_logradouro}}</p>

                </b-card>

                <b-card
                  class="mb-2"
                  header="Benefício(s) selecionado(s)">

                  <p v-for="beneficio in beneficiosSelecionados" :key="beneficio.id">
                    {{beneficio.nome_beneficio}}
                  </p>

                </b-card>

                <div class="text-center mt-3">
                  <b-button class="mr-2" variant="info" @click="back" v-if="!liberaImpressao">VOLTAR</b-button>
                  <b-button variant="success" @click="confirmar" v-if="!liberaImpressao">CONFIRMAR</b-button>
                  <b-link :href="url" class="btn btn-success" v-if="liberaImpressao" target="_blank">IMPRIMIR COMPROVANTE</b-link>
                </div>
              </div>
            </div>

        </div>
    </div>
  </div>
  
</template>

<script>
import api from '../requests';
import {formatDate} from '../helpers';

export default {
  name: "confirmacao",
  data() {
      return {
          erro: null,
          dados: null,
          tipos: [
            { text: 'Selecione', value: null },
            { text: 'RG - Registro Geral', value: 1 },
            { text: 'CNH - Carteira Nacional de Habilitação', value: 2 },
            { text: 'Passaporte', value: 3 },
            { text: 'CTPS - Carteira de Trabalho e Previdência Social', value: 4 },
            { text: 'CIE - Carteira de Identidade de Estrangeiros', value: 5 },
            { text: 'RNE - Registro Nacional de Estrangeiros', value: 6 }
          ],
          beneficiosSelecionados: [],
          liberaImpressao: false,
          url: "",
      }
  },
  computed: {
      dadosForm() {
        return this.$store.getters.dadosForm;
      },
      beneficios() {
        return this.$store.getters.beneficios;
      },
  },
  methods: {
    formatarSexo(sexo){
      if(sexo === 'M'){
        return 'Masculino'
      }else if(sexo === 'F'){
        return 'Feminino'
      }else{
        return 'Outros'
      }
    },
    formatDate,
    removeAcentos(string) {
      var texto = string;
      var semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
      return semAcento;
    },
    back() {
        this.$router.back();
    },
    confirmar(){
        this.$bvModal.msgBoxConfirm('Confirma o envio dos dados?', {
            title: false,
            centered: true,
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            showCancelButton: false,
        }).then(async value => {
          if( value ) {
            try {
                
              this.dadosForm.dados.bairro = this.removeAcentos(this.dadosForm.dados.bairro);
              this.dadosForm.dados.logradouro = `${this.dadosForm.dados.tipo_logradouro} ${this.dadosForm.dados.endereco}, ${this.dadosForm.dados.numero_logradouro} - ${this.dadosForm.dados.bairro}`;

              const result = await api.post('confirma-dados', this.dadosForm);
              
              this.$bvModal.msgBoxOk('Solicitação de pagamento do Auxílio Pecuniário Estamos Juntos realizada com sucesso.', {
                title: false,
                buttonSize: 'sm',
                centered: true, 
                size: 'sm'
              }).then(() => {
                //this.$router.push("/");
                this.url = `${this.$env.VUE_APP_URL_API}/api/comprovante/${result.data.protocolo}`;
                this.liberaImpressao = true;
              });

            }catch (e) {
              this.erro = "Falha ao salvar os dados. Tente novamente em instantes.";
            }
          }
      })
      .catch(err => {
        console.log(err);
      });
    }
  },
  mounted() {
    this.beneficiosSelecionados = this.beneficios.filter(b => this.dadosForm.dados.selected.includes(b.id));
  }
};
</script>